export const paramWhitelists = {
  trips: [`from_date`, `to_date`, `sort_order`, `sort_key`, `term`, `limit`],
}

export const sanitizeParams = async (search: URLSearchParams, whitelist: ReadonlyArray<string>): Promise<string> => {
  const sanitizedParams = new URLSearchParams()

  search.forEach((value, key) => {
    if (whitelist.includes(key)) sanitizedParams.append(key, value)
  })

  return sanitizedParams.toString() === `` ? `` : `?${sanitizedParams.toString()}`
}
